import Logo from '../Logo/Logo';
import styles from './Header.module.css';

function Header() {
  return (
    <header className="d-flex align-items-center justify-content-between py-4">
      <a href="/" className="d-inline-flex align-items-center" aria-label="Home">
        <Logo height={40} />
      </a>
      <a href="https://www.team-pow.com/application" className={`${styles.apply} btn`}>
        Apply now
      </a>
    </header>
  );
}

export default Header;
